/**
 * IMPORTANT: English comments only. DO NOT use Chinese characters in comments.
 * All Chinese comments will be removed during code reviews.
 */

/**
 * Phone number utilities for formatting and normalization
 */

/**
 * Normalize phone number by removing non-digit characters and handling Thai country code
 * @param phone Raw phone number input
 * @returns Normalized phone number without country code
 */
export function normalizePhoneNumber(phone: string): string {
  if (!phone) return '';
  
  // Remove any non-digit characters
  let normalizedPhone = phone.replace(/\D/g, '');
  
  // Remove leading '66' if it exists (Thai country code)
  if (normalizedPhone.startsWith('66')) {
    normalizedPhone = normalizedPhone.substring(2);
  }
  
  // If resulting number starts with a 0, keep it, otherwise add it
  if (!normalizedPhone.startsWith('0')) {
    normalizedPhone = '0' + normalizedPhone;
  }
  
  return normalizedPhone;
}

/**
 * Format phone number for display
 * @param phone Raw phone number
 * @returns Formatted phone number with proper spacing
 */
export function formatPhoneForDisplay(phone: string): string {
  const normalized = normalizePhoneNumber(phone);
  
  if (!normalized || normalized.length < 10) return phone;
  
  // Format as 0xx xxx xxxx for Thai numbers (standard Thai mobile format)
  try {
    return `${normalized.substring(0, 3)} ${normalized.substring(3, 6)} ${normalized.substring(6)}`;
  } catch (e) {
    return phone;
  }
} 